import { useEffect } from "react";
import { fetchProfile } from "../api/profiles";
import { useAuth } from "../auth/AuthContext";
import { useLanguage } from "./LanguageContext";

export const ProfileLanguageSync = () => {
  const { user, loading } = useAuth();
  const { setLanguageFromProfile } = useLanguage();

  useEffect(() => {
    if (loading || !user) return undefined;

    let cancelled = false;
    fetchProfile()
      .then((profile) => {
        if (!cancelled) {
          setLanguageFromProfile(profile?.language);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [loading, user, setLanguageFromProfile]);

  return null;
};
